import {
  Box, Button, Container, Divider, Grid, IconButton, InputBase, Pagination,
  Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow,
  Backdrop, CircularProgress, FormControl, InputLabel, Select, MenuItem,
  Typography, TextField, InputAdornment,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { StyledTableCell, tableStyle } from "../Pays/Pays";
import { useContext, useEffect, useState } from "react";
import axios, { AxiosInstance } from "axios";
import { urlApi } from "../Pays/RowPays";
import RowClient from "./RowClient";
import Cookies from "universal-cookie";
import { ClientInterface } from "./InterfaceClient";
import RefreshIcon from "@mui/icons-material/Refresh";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import { AlertType } from "../../../../types/AlertType";
import CheckAttr from "../../../../utils/CheckAttr";
import ClearIcon from "@mui/icons-material/Clear";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";

const Client = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const [loader, setLoader] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [errorinputSearch, setErrorinputSearch] = useState<boolean>(false);

  const [page, setPage] = useState<number>(1);
  const [rowPerPage, setRowPerPage] = useState<number>(5);
  const [totalNumber, setTotalNumber] = useState<number>(0);
  const [clientRows, setClientRows] = useState<ClientInterface[]>([]);
  const [newClient, setNewClient] = useState<string>('');
  const [expanded, setExpanded] = useState<number | false>(false);

  const [alertMessage, setAlerteMessage] = useState<string>('');
  const [clientSearch, setClientSearch] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  const getDataClient = async () => {
    setLoader(true);
    setClientRows([]);
    setTotalNumber(0);
    await http.post(`client/search`, {
      rowPerPage,
      page,
      clientSearch: clientSearch
    }).then((res) => {
      const { data, total } = res.data;
      setClientRows(data);
      setTotalNumber(total);
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      setLoader(false);
    });
  };

  // Click Search
  const ClickSearch = () => {
    setErrorinputSearch(false);
    if (CheckAttr(clientSearch)) {
      getDataClient();
    } else {
      setErrorinputSearch(true);
      setAlerteMessage("Merci de remplir le champ de recherche SVP!");
      setAlertType("warning");
      setOpenSnack(true);
    }
  };

  useEffect(() => {
    getDataClient();
  }, [page, rowPerPage, refresh]);

  const handleReload = () => {
    setRefresh(!refresh);
  }

  const handleRefresh = () => {
    setPage(1);
    setRowPerPage(5);
    setNewClient('');
    setClientSearch('');
    handleReload();
  }

  const handleSave = () => {
    if (CheckAttr(newClient)) {
      setLoader(true);
      http.post(`client/save`, { newClient: newClient })
        .then((res) => {
          const { existence, message } = res?.data;

          if (existence > 0) {
            setAlerteMessage(message);
            setAlertType("warning");
            setOpenSnack(true);
          } else {
            handleRefresh();
            setAlerteMessage(message);
            setAlertType("success");
            setOpenSnack(true);
          }
        }).catch((error) => {
          console.log(error);
        }).finally(() => {
          setLoader(false);
        });
    } else {
      setAlerteMessage("Merci de remplir le champ pour l'ajout SVP!");
      setAlertType("warning");
      setOpenSnack(true);
    }
  };

  const handleChangeRowPerPage = (e: any) => {
    setRowPerPage(e.target.value as number);
    setPage(1);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false)
  }

  const pagination: JSX.Element | boolean = !loader && (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowPerPage}
          onChange={handleChangeRowPerPage}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {totalNumber > rowPerPage && (
        <Pagination
          count={Math.ceil(totalNumber / rowPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => setPage(value)}
        />
      )}
    </Stack>
  );

  const stackAlert: JSX.Element = SnackBarAlert(openSnack, handleCloseAlert, alertType, alertMessage);

  return (
    <>
      <Container maxWidth="md">
        {isDesktopOrLaptop ? (
          <>
            <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
              <Grid item xs={6} sm={6} md={8}>
                <Stack
                  direction="row"
                  spacing={3}
                  sx={{ ml: 2 }}
                  display="flex"
                  justifyContent="start"
                >
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<AddIcon />}
                    onClick={() => handleSave()}
                    style={{ textTransform: "none" }}
                  >
                    Ajouter
                  </Button>
                  <InputBase
                    sx={{ color: "white" }}
                    value={newClient}
                    placeholder="Client"
                    onChange={(e) => setNewClient(e.target.value)}
                  // fullWidth
                  />
                </Stack>
              </Grid>
              <Grid item xs={5.5} sm={3.5} md={3.5}>
                <Stack
                  direction="row"
                  spacing={3}
                  sx={{ ml: 2 }}
                  display="flex"
                  justifyContent="end"
                >
                  <InputBase
                    sx={{ color: "white" }}
                    value={clientSearch}
                    error={errorinputSearch}
                    placeholder="Chercher un Client"
                    onChange={(e) => setClientSearch(e.target.value)}
                  />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px", color: "white" }}
                    aria-label="search"
                    onClick={() => ClickSearch()}
                  >
                    <SearchIcon />
                  </IconButton>
                </Stack>
              </Grid>
              <Grid item xs={0.5} sm={0.5} md={0.5}>
                <IconButton
                  aria-label="refresh"
                  sx={{ color: "#fff", pt: 0.5 }}
                  onClick={() => handleRefresh()}
                >
                  <RefreshIcon sx={{ fontSize: 35 }} />
                </IconButton>
              </Grid>
            </Grid>

            <Box mt={4} display="flex" justifyContent="left">
              {pagination}
            </Box>

            <TableContainer component={Paper} style={tableStyle} sx={{ mt: 1 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">Client</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clientRows.map((row) => (
                    <RowClient
                      key={row?.id}
                      row={row}
                      http={http}
                      isDesktopOrLaptop={isDesktopOrLaptop}
                      setOpenSnack={setOpenSnack}
                      setAlerteMessage={setAlerteMessage}
                      setAlertType={setAlertType}
                      handleReload={handleReload}
                      expanded={expanded}
                      setExpanded={setExpanded}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box display="flex" justifyContent="right" mt={3} mr={6}>
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1
                }}
                placeholder="Ajouter un nouveau client ..."
                size="small"
                fullWidth
                value={newClient}
                onChange={(e) => setNewClient(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="add"
                        onClick={() => handleSave()}
                      >
                        <AddIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1,
                  mt: 0.5,
                }}
                placeholder="Chercher un client ..."
                size="small"
                fullWidth
                value={clientSearch}
                error={errorinputSearch}
                onChange={(e) => setClientSearch(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => ClickSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        type="button"
                        aria-label="refresh"
                        onClick={() => handleRefresh()}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Typography sx={{ mt: 3 }}>Liste des Clients</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 2 }} />

              <Box display="flex" justifyContent="end">
                <Pagination
                  count={Math.ceil(totalNumber / rowPerPage)}
                  size="small"
                  color="standard"
                  sx={{ button: { color: "white" }, mb: 2 }}
                  showFirstButton={true}
                  showLastButton={true}
                  siblingCount={0}
                  boundaryCount={1}
                  defaultPage={page}
                  onChange={(event, value) => setPage(value)}
                />
              </Box>
            </Box>

            <Box mt={25}>
              {clientRows.map((row) => (
                <RowClient
                  key={row?.id}
                  row={row}
                  http={http}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  setOpenSnack={setOpenSnack}
                  setAlerteMessage={setAlerteMessage}
                  setAlertType={setAlertType}
                  handleReload={handleReload}
                  expanded={expanded}
                  setExpanded={setExpanded}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>Lignes par page :</InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12
                  }}
                  value={rowPerPage}
                  onChange={handleChangeRowPerPage}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}
      </Container>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      {stackAlert}
    </>
  );
};

export default Client;

